import React, { useState } from 'react';
import { Heading } from '@chakra-ui/react';

import { NumberTrack } from '../../../presentational/NumberTrack';

import { useStoreState } from 'pullstate';
import { CharacterStore } from '../../../../stores/characterStore';

export function FeralTrack({ value, max, onChange = () => {}, ...props }) {
  const [tempVal, setTempVal] = useState(null);

  const showTransform = (tempVal || value) === max;

  return (
    <NumberTrack
      value={tempVal || value}
      label="Feral"
      onChange={val => {
        setTempVal(val);
        onChange(val);
      }}
      showHidden={showTransform}
      hiddenMsg="Transform!"
      {...props}
    >
      <Heading
        textStyle="heading"
        as="i"
        lineHeight={1.2}
        fontSize={{ base: 'xs', sm: 'sm', md: 'md' }}
      >
        Transform!
      </Heading>
    </NumberTrack>
  );
}

export function BeastStats(props) {
  const feral = useStoreState(CharacterStore, s => s?.stats?.feral);
  if (feral === null) {
    return null;
  }
  const max = 4;

  return (
    <FeralTrack
      value={feral}
      max={max}
      onChange={val => {
        CharacterStore.update(s => {
          s.stats ?? (s.stats = {});
          s.stats.feral = val;
        });
      }}
      {...props}
    />
  );
}
